export default {
  auth: {
    logged_in: "Xin chào, ",
    logout: "Đăng xuất",
    logged_out: "Đăng xuất thành công",
    invalid: "Thông tin không hợp lệ. Xin vui lòng đăng nhập lại."
  }
};
